// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M1.66797 3.83333C1.66797 3.36662 1.66797 3.13327 1.7588 2.95501C1.83869 2.79821 1.96617 2.67072 2.12298 2.59083C2.30124 2.5 2.53459 2.5 3.0013 2.5H17.0013C17.468 2.5 17.7014 2.5 17.8796 2.59083C18.0364 2.67072 18.1639 2.79821 18.2438 2.95501C18.3346 3.13327 18.3346 3.36662 18.3346 3.83333V4.39116C18.3346 4.61516 18.3346 4.72716 18.3073 4.8313C18.283 4.92359 18.2431 5.01103 18.1892 5.0898C18.1285 5.17869 18.0438 5.25204 17.8745 5.39875L12.5447 10.0179C12.3755 10.1646 12.2908 10.238 12.23 10.3269C12.1762 10.4056 12.1363 10.4931 12.112 10.5854C12.0846 10.6895 12.0846 10.8015 12.0846 11.0255V15.382C12.0846 15.5449 12.0846 15.6264 12.0584 15.6969C12.0351 15.7591 11.9974 15.8149 11.9482 15.8596C11.8925 15.9102 11.8169 15.9404 11.6656 16.001L8.83223 17.1343C8.52594 17.2568 8.3728 17.3181 8.24986 17.2925C8.14236 17.2702 8.04801 17.2063 7.98735 17.1148C7.91797 17.0101 7.91797 16.8452 7.91797 16.5153V11.0255C7.91797 10.8015 7.91797 10.6895 7.8906 10.5854C7.86634 10.4931 7.82641 10.4056 7.77256 10.3269C7.71178 10.238 7.62715 10.1646 7.45788 10.0179L2.12806 5.39875C1.95879 5.25204 1.87415 5.17869 1.81338 5.0898C1.75952 5.01103 1.7196 4.92359 1.69534 4.8313C1.66797 4.72716 1.66797 4.61516 1.66797 4.39116V3.83333Z"
    />
  </svg>
);
const IconFunnel = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconFunnel;
